AFRAME.registerPrimitive('a-hotspot', {
  defaultComponents: {
    hotspot: {}
  },
  mappings: {
    for: 'hotspot.for',
    to: 'hotspot.to'
  }
});

AFRAME.registerComponent('hotspot', {
  schema: {
    for: { type: 'string' },
    to: { type: 'string' },
  },

  init: function () {
    this.tour = document.querySelector('a-tour');
    this.el.addEventListener('click', this.handleClick.bind(this));

    this.el.setAttribute('animation__enter', {"property": "material.opacity", "from": "0.1", "to": "0.6", "dur": "150", "startEvents": "mouseenter"});
    this.el.setAttribute('animation__leave', {"property": "material.opacity", "from": "0.6", "to": "0.0", "dur": "1", "startEvents": "mouseleave"});
  },

  handleClick: function () {
    var tour = this.tour.components['tour'];
    tour.loadSceneId(this.data.to);
  }
});
